<script setup lang="ts">
import type { components } from '@core/types/clients/strapi'
import type { AspectRatio } from '@nimbus/types'
import { computed, useStrapiMedia } from '#imports'

export interface StrapiVideoProps {
    media: components['schemas']['DynamicMediaTextComponent']['media'] | null
    aspectRatio?: AspectRatio
}

const props = withDefaults(defineProps<StrapiVideoProps>(), {
    aspectRatio: '16/9'
})

const paddingTop = computed(() => {
    const [width, height] = props.aspectRatio.split('/')

    const percentage = Number(height) / Number(width) /* ex. 16/9 Aspect Ratio (divide 9 by 16 = 0.5625) */

    return `${percentage * 100}%`
})

const { getStrapiMediaUrl, getStrapiMediaAttr } = useStrapiMedia()
const mediaAttr = computed(() => getStrapiMediaAttr(props.media ?? undefined))
</script>

<template>
    <div v-if="mediaAttr?.url" class="video-container" :style="{ paddingTop }">
        <video
            autoplay
            loop
            muted
            playsInline
            disableRemotePlayback
            decoding="async"
            preload="none"
            loading="lazy"
            :src="`${getStrapiMediaUrl(mediaAttr?.url)}`"
        />
    </div>
</template>

<style scoped lang="scss">
.video-container {
    position: relative;
    border-radius: inherit;

    video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: inherit;
        object-fit: cover;
    }
}
</style>
